/**
 * Custom Calendar Background
 *
 * Declares exactly one web-accessible resource — options.html — matched to <all_urls>
 * with no `use_dynamic_url`. That single page is fetchable at a fixed URL from any page,
 * which is enough to identify the extension: the resource is served only when installed
 * and the ID is fixed in the URL.
 *
 * There is no image or second WAR to corroborate with, so this is a single fetch and a
 * single-signal module.
 *
 * Manifest verified against version 2.0.16.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'acjecbgflnhmeldadcbblhfdimhifpki';

export const customCalendarBackground: ExtensionDefinition = {
  id: ID,
  name: 'Custom Calendar Background',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'Only one WAR — options.html — exposed to every origin with no dynamic URL. A single ' +
    'fetch is conclusive.',
  signals: [
    {
      id: 'war-options-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch options.html — the sole web-accessible resource, served at a fixed URL only ' +
        'when the extension is installed.',
      weight: 1,
      run: () => probeFetch(ID, 'options.html'),
    },
  ],
};
